/* eslint-disable no-unused-vars */
import { View, StyleSheet } from '@react-pdf/renderer';
import React from 'react';
import BudgetDataClient from './BudgetDataClient';
import BudgetRecord from './BudgetRecord';
import BudgetGuarantee from './BudgetGuarantee';
import BudgetConditions from './BudgetConditions';
import BudgetDataTransfer from './BudgetDataTransfer';
import BudgetFinish from './BudgetFinish';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: '0.5cm',
  },
  section: {
    marginBottom: '1.5cm',
    padding: '0.8cm',
    backgroundColor: '#ffffff',
    borderRadius: '0.3cm',
    border: '1px solid #e8e8e8',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  sectionTitle: {
    fontFamily: 'Helvetica-Bold',
    fontSize: '14px',
    color: '#2c3e50',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '0.8cm',
    paddingBottom: '0.3cm',
    borderBottom: '2px solid #548235',
  },
  sectionContent: {
    fontSize: '11px',
    color: '#34495e',
    lineHeight: 1.4,
  },
});

function BudgetBody(props) {
  const { budget, items, images, config, staticData, template, templateColors } = props;
  return (
    <View style={styles.container}>
      {/* Sección 1: Datos del Cliente */}
      <View style={styles.section}>
        <BudgetDataClient budget={budget} />
      </View>

      {/* Sección 2: Antecedentes y Fundamentos Técnicos - Nueva Página */}
      <View style={[styles.section]} break>
        <BudgetRecord
          items={items}
          description={budget.description}
          images={images}
          discount={budget.discount}
          moneda={budget.moneda}
          tipoCambioSnapshot={budget.tipo_cambio_snapshot}
          template={template}
          templateColors={templateColors}
        />
      </View>

      {/* Sección 3: Garantía de los Trabajos */}
      <View style={styles.section}>
        <BudgetGuarantee guarantee={budget.guarantee} />
      </View>

      {/* Sección 4: Condiciones */}
      <View style={styles.section} wrap={false}>
        <BudgetConditions
          conditions={budget.conditions}
          finishTime={budget.finishTime}
          include={budget.include}
        />
      </View>

      {/* Sección 5: Datos de Transferencia */}
      <View style={styles.section} wrap={false}>
        <BudgetDataTransfer staticData={staticData} />
      </View>

      {/* Sección 6: Despedida y Firma */}
      <View style={styles.section} wrap={false}>
        <BudgetFinish config={config} staticData={staticData} />
      </View>
    </View>
  );
}

export default BudgetBody;
